<script setup>

import {inject} from 'vue'
import Icon from '../Icon.vue'

const document = inject('document')
const {saveDocument} = inject('appActions')

</script>

<template>
  <div>
  <Icon v-if="document.starred" 
    name="heroicons--star-solid" :size="20" class="starring starred" style="margin-left: 5px;"
    @click="() => {delete document.starred; saveDocument()}"
  />
  <Icon v-else name="heroicons--star" :size="20" class="starring golden-hover" style="margin-left: 5px;"
    @click="() => {document.starred = true; saveDocument()}"
  />
</div>
</template>

<style scoped>
.starring {
  cursor: pointer;
}
.golden-hover:hover {
  color: gold
}
.starred {
  color: gold
}
</style>
